import useWindowSize from '../../../hooks/useWindowSize';
import { BootstrapBreakpoints } from '../../../utils/constants';
import NoRecordLogo from '../../../assets/logo/No_record_logo.png';
import TransactionCard from './TransactionCard';
import { appendLocale } from '../../../utils/helper';
import { useDict } from '../../../contexts/LanguageContext';

const TransactionList = (props) => {
    const dict = useDict();
    const { transactionData } = props;
    const { width } = useWindowSize();
    const isMobile = width <= BootstrapBreakpoints.SM;

    if (transactionData && transactionData.length > 0) {
        return (
            <>
                {transactionData.map((data) => (
                    <TransactionCard
                        key={data.id}
                        investmentNote={data.investment_note}
                        date={data.created_at}
                        activityName={data.cashflow_type[appendLocale('name')]}
                        amount={data.amount}
                        flow={data.cashflow_type[appendLocale('name')]}
                        status={data.success}
                        flowId={data.id}
                    />
                ))}
            </>
        );
    }
    return (
        <div className="d-flex flex-column align-items-center mt-4 mb-4">
            <img
                src={NoRecordLogo}
                alt="noRecord"
                style={{
                    width: isMobile ? '60%' : '30%',
                    objectFit: 'contain',
                    minHeight: isMobile ? '20vh' : undefined,
                }}
            />
            <p className="mt-3 font-size-20">{dict.noRecordAvailable}</p>
        </div>
    );
};

export default TransactionList;
